import React from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, Link } from 'react-router-dom';

import SidebarHashLink from './SidebarHashLink';

import LoginIcon from '../icons/LoginIcon';
import actions from '../../../actions';

const SidebarContentDesktop = props => {
  const dispatch = useDispatch();
  const history = useHistory();

  const logout = e => {
    e.preventDefault();
    dispatch(actions.authLogout());
    history.push('/auth');
  };

  const { isAuthenticated } = useSelector(state => state);

  return (
    <>
      <SidebarHashLink containerId="start-screen-container-id" onClick={props.closeSidebar} name="Main" />
      <SidebarHashLink containerId="info-screen-container-id" onClick={props.closeSidebar} name="About" />
      <Link to="/courses" className="sidebar-link">
        Courses
      </Link>
      <SidebarHashLink containerId="faq-screen-container-id" onClick={props.closeSidebar} name="FAQ" />
      <SidebarHashLink containerId="request-screen-container-id" onClick={props.closeSidebar} name="Contacts" />

      <div className="sidebar-separator" />
      {!isAuthenticated && (
        <Link to="/auth" className="sidebar-link">
          <div className="is-flex align-items-center">
            <span className="mr-10px">Sign In</span>
            <LoginIcon className="sidebar-link-icon" />
          </div>
        </Link>
      )}
      {isAuthenticated && (
        <>
          <Link to="/profile" className="sidebar-link">
            Profile
          </Link>
          <a href="#" onClick={logout} className="sidebar-link">
            Sign out
          </a>
        </>
      )}
    </>
  );
};

SidebarContentDesktop.propTypes = {
  closeSidebar: PropTypes.func.isRequired,
};

export default SidebarContentDesktop;
